import Config from 'config'
import HttpProvider from '@/services/HttpProvider'
import actions from '@/store/modules/cart/actions'
import { toast } from 'theme/modules/notifications'
import { getSuffixGuest } from '@/helpers'
import { invalidateCartSession } from 'theme/helpers'

actions.update = (ctx, { sku, itemId, qty, append = false, variant, noSync = false }) => {
  let itemFromCart
  let newQty = qty
  // add product to cart
  return ctx.dispatch('getCartID', {})
    .then(() => {
      let findFor = itemId || sku
      itemFromCart = ctx.state.items.find(item => {
        return item.item_id === findFor || item.sku === findFor
      })

      if (newQty < 1 && newQty < itemFromCart.qty && itemFromCart) {
        return ctx.dispatch('delete', itemFromCart.item_id)
      }

      const params = {
        cartItem: {
          item_id: itemFromCart ? itemFromCart.item_id : undefined,
          qty: append ? newQty + (itemFromCart ? itemFromCart.qty : 0) : newQty,
          quoteId: ctx.state.cartId,
          sku: sku
        }
      }
      // configurable product
      if (variant) {
        let configurableItemOptions = []
        for (let key in variant) {
          configurableItemOptions.push({
            option_id: key,
            option_value: variant[key]
          })
        }
        params.cartItem.product_option = {
          extension_attributes: {
            configurable_item_options: configurableItemOptions
          }
        }
      }
      let url = !itemFromCart ? Config.API.cart[`add${getSuffixGuest(ctx.rootGetters)}`] : Config.API.cart[`update${getSuffixGuest(ctx.rootGetters)}`]
      url = url
        .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
        .replace('{{token}}', ctx.rootState.user.token || '')
        .replace('{{itemId}}', itemFromCart ? itemFromCart.item_id : '')
        .replace('{{cartId}}', ctx.state.cartId)
      const axiosCall = !itemFromCart ? HttpProvider.post : HttpProvider.put
      return axiosCall(url, params)
    })
    .then((res) => {
      if (!noSync) {
        return ctx.dispatch('syncServerCart', {}).then(() => res.data)
      }
      return res.data
    })
    .then((cart) => {
      if (cart.cart_id) {
        ctx.commit('updCartId', cart.cart_id)
      }
    })
}

actions.delete = (ctx, item) => {
  let itemId = item.item_id
  const query = Config.API.cart[`delete${getSuffixGuest(ctx.rootGetters)}`]
    .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
    .replace('{{cartId}}', ctx.state.cartId)
    .replace('{{itemId}}', itemId)
  return HttpProvider.delete(query, { itemsMap: item.delete_map })
    .then((resp) => {
      if (resp.data && resp.data.cart_id) {
        ctx.commit('updCartId', resp.data.cart_id)
      }
      return ctx.dispatch('syncServerCart', {})
    })
}

actions.addCoupon = (ctx, couponId) => {
  const query = Config.API.cart.addCoupon
    .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
    .replace('{{cartId}}', ctx.state.cartId)
    .replace('{{couponId}}', couponId)
  return HttpProvider.post(query)
    .then((res) => {
      if (res.data && res.data.cart_id) {
        ctx.commit('updCartId', res.data.cart_id)
      }
      return res.data
    })
}

actions.deleteCoupon = (ctx, { cartId, couponId }) => {
  const query = Config.API.cart.deleteCoupon
    .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
    .replace('{{cartId}}', cartId)
    .replace('{{couponId}}', couponId)
  return HttpProvider.delete(query)
    .then((res) => {
      if (res.data && res.data.cart_id) {
        ctx.commit('updCartId', res.data.cart_id)
      }
      return res.data
    })
}

actions.setRewardOnCart = (ctx, reward) => {
  const query = Config.API.cart.cartCustomAttributes
    .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
  return HttpProvider.post(query, {
    cart_id: ctx.state.cartId,
    code: reward.code,
    points: reward.points
  })
}

actions.totals = (ctx) => {
  let url = Config.API.cart[`totals${getSuffixGuest(ctx.rootGetters)}`]
    .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
    .replace('{{cartId}}', ctx.state.cartId)
  return HttpProvider.get(url)
    .then(res => res.data)
    .then(basket => {
      return ctx.commit('updCart', basket)
    })
    .catch((error) => {
      invalidateCartSession(ctx, error)
      let message = global.$i18n.t('GenericError')
      if (error.message) {
        message = error.message
      }
      if (error && error.response && error.response.data && error.response.data.message) {
        message = global.$i18n.t(error.response.data.message)
      }
      toast.error(message)
    })
}

actions.empty = (ctx) => {
  ctx.commit('updCartId', null)
  ctx.commit('updCartIdMask', null)
  ctx.commit('updCartItems', { items: [], invalid: true })
  ctx.commit('updPullItems', { items: [] })
  ctx.commit('updCart', { })
  ctx.commit('setGiftCards', [])
  ctx.commit('setActiveGiftCards', [])
  ctx.dispatch('checkout/empty', null, { root: true })
}

export default {
  ...actions
}
